"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePreferencesTab = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_self_1 = __importDefault(require("@opsbase/lib-self"));
const App_1 = __importDefault(require("@opsbase/lib-system/App"));
const Features_1 = require("@opsbase/lib-system/Features");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const useSelfUpdate_1 = __importDefault(require("@opsbase/react-gql-hooks/self/useSelfUpdate"));
const react_markdown_1 = __importDefault(require("@opsbase/react-markdown"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const LanguagePicker_1 = __importDefault(require("@opsbase/web-pickers/LanguagePicker"));
const FeatureFlagged_1 = __importDefault(require("@opsbase/web-ui/FeatureFlagged"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const Switch_1 = __importDefault(require("@opsbase/web-ui/Switch"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function ProfilePreferencesTab() {
    const self = (0, useSelf_1.default)(true);
    const { setRealSelfOnly } = (0, useSelfActions_1.default)();
    const selfUpdate = (0, useSelfUpdate_1.default)();
    const isSuperUser = self.isSuperUser;
    const doUpdatePreferences = (0, react_1.useCallback)((preferences) => __awaiter(this, void 0, void 0, function* () {
        return selfUpdate({
            preferences: Object.assign(Object.assign({}, self.preferences), preferences),
        }, {
            context: { forceReal: true },
        }).then(data => {
            setRealSelfOnly(lib_self_1.default.fromData(data));
        });
    }), [self, selfUpdate, setRealSelfOnly]);
    const handleChangeNotificationDailyDigest = (0, react_1.useCallback)(notificationDailyDigest => doUpdatePreferences({ notificationDailyDigest }), [doUpdatePreferences]);
    const handleChangeNotificationWeeklyDigest = (0, react_1.useCallback)(notificationWeeklyDigest => doUpdatePreferences({ notificationWeeklyDigest }), [doUpdatePreferences]);
    const handleChangeNotificationEmail = (0, react_1.useCallback)(notifyByEmail => {
        doUpdatePreferences({ notifyByEmail }).catch(doNothing_1.default);
    }, [doUpdatePreferences]);
    const handleChangeNotificationPush = (0, react_1.useCallback)(notifyByPush => {
        doUpdatePreferences({ notifyByPush }).catch(doNothing_1.default);
    }, [doUpdatePreferences]);
    const handleChangeLanguage = (0, react_1.useCallback)(language => {
        doUpdatePreferences({ language }).catch(doNothing_1.default);
    }, [doUpdatePreferences]);
    return (react_1.default.createElement(Spinner_1.default, { busy: false },
        !isSuperUser && (react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true, padding: true },
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('notification-question')),
            react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true },
                react_1.default.createElement(Switch_1.default, { checked: self.preferences.notifyByEmail, onChange: handleChangeNotificationEmail, label: lib_i18n_1.default.t('notify-email') }),
                react_1.default.createElement(Switch_1.default, { checked: self.preferences.notifyByPush, onChange: handleChangeNotificationPush, label: lib_i18n_1.default.t('notify-push') })))),
        react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true, padding: true },
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('prefered-language')),
            react_1.default.createElement(LanguagePicker_1.default, { white: true, noMargin: true, value: self === null || self === void 0 ? void 0 : self.preferences.language, onChange: handleChangeLanguage }),
            isSuperUser && react_1.default.createElement(Text_1.default, null, (0, react_markdown_1.default)(lib_i18n_1.default.t('superuser-language-note')))),
        !isSuperUser && (react_1.default.createElement(FeatureFlagged_1.default, { flag: Features_1.FeatureSets[App_1.default.OPSBASE].OPS_LOG.key },
            react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true, padding: true },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('digest-email-question')),
                react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true },
                    react_1.default.createElement(Switch_1.default, { checked: self.preferences.notificationDailyDigest, onChange: handleChangeNotificationDailyDigest, label: lib_i18n_1.default.t('send-daily-digest') }),
                    react_1.default.createElement(Switch_1.default, { checked: self.preferences.notificationWeeklyDigest, onChange: handleChangeNotificationWeeklyDigest, label: lib_i18n_1.default.t('send-weekly-digest') })))))));
}
exports.ProfilePreferencesTab = ProfilePreferencesTab;
exports.default = ProfilePreferencesTab;
